export default{
    methods:{
        goLogin(){//跳登录界面
          this.$router.push({path:'/login'});
        },
        getUrl(){
           return  this.$route.query;
        },
        goBack(){
            this.$router.go(-1);
        },
        seleBlur(obj){
            obj.target.className = '';
        },
        goRoute(url,data){//直接跳转
            if(!url){
                return
            }
            if(data){
              localStorage.setItem('checkData',JSON.stringify(data));
            }
            this.$router.push({path:url})
        },
        async getBanner(id,url){
          const {code,result} = await getDemoData('/geopark/imageSettings/findById',{id});
          if(code==200){
            this[url] = result.imagePath;
          }
        },
        goTitle(index){
          if(index==0) return
          let idx = index-1;
          let height = this.$el.querySelectorAll('.listTitle')[idx].offsetTop; //title距离顶部的高度
          window.scrollTo({"behavior": "smooth", "top": height-100});
        },
        scrollToTitle(activeIndex,vm){
          let that = this;
          window.onscroll = function(e){
            let $winHeight = document.body.clientHeight; // 窗口可视区域的高度
            let $winScrollHeight = document.documentElement.scrollTop || document.body.scrollTop; // 浏览器滚动的距离
            let moveBoxArr = that.$el.querySelectorAll(".listTitle");
            moveBoxArr.forEach((item, index) => {
              if ($winHeight/5  + ($winScrollHeight-200) >= item.offsetTop) {
                vm.activeIndex = index
              }else{
                // vm.activeIndex = 0
              }
            });
          }
        },
        goDetail(id,type){ //跳转到详情页
          let path = '';
          switch (type){
            case 'destination': //目的地
              path = '/ticketDetail'
              break;
            case 'spot': //景点 门票详情
              path = '/ticketInfoDetail'
              break;
            case 'hotel': //酒店
              path = '/hotelDetail'
              break;
            case 'restaurant': //餐饮
              path = '/restaurantDetail'
              break;
            case 'explanation': //旅游讲解
              path = '/explanationDetail'
              break;
            case 'specialProduct': //特色产品
              path = '/specialProductDetail'
              break;
            case 'travelNotes': //游记详情
              path = '/travelNotesDetail'
              break;
            default:
              path = '/restaurantDetail'
              break;
          }
          this.$router.push({
            path,
            query:{id}
          })
        },
        goMore(type,search){
          let path = '';
          switch (type){
            case 'destination': //目的地
              path = '/destination'
              break;
            case 'spot': //景点
              path = '/ticket'
              break;
            case 'hotel': //酒店
              path = '/hotel'
              break;
            case 'restaurant': //餐饮
              path = '/restaurant'
              break;
            case 'travelNotes': //游记攻略
              path = '/travelNotes'
              break;
            case 'specialProduct': //特产列表
              path = '/specialProduct'
              break;
            default:
              path = '/'
              break;
          }
          this.$router.push({
            path,
            query:{
              search
            }
          })
        },
        handleNum(num) { //根据浏览量判断星级
              var count = 0;
              switch (num) {
                  case num<500:
                      cobs
                      count = 0;
                      break;
                  case num>=500&&num<2000:
                      count = 1;
                      break;
                  case num>=2000&&num<5000:
                      count = 2;
                      break;
                  case num>5000&&num<1000:
                      count = 3;
                      break;
                    
            }
            return count;
        },
        local_getItem(name){// 本地储存加密
          try{
            return decodeURIComponent(escape(atob(localStorage.getItem(name)||"")))
          }catch(e){
            return localStorage.getItem(name)
          }
        },
        local_setItem(name,obj){
          localStorage.setItem(name,btoa(unescape(encodeURIComponent(obj))))
        },
        session_getItem(name){
          try{
            return decodeURIComponent(escape(atob(sessionStorage.getItem(name)||"")))
          }catch(e){
            return sessionStorage.getItem(name)
          }
        },
        session_ssetItem(name,obj){
          sessionStorage.setItem(name,btoa(unescape(encodeURIComponent(obj))))
        },
        reg_phone(str,type){// 正则判断 手机号
          if(!str) return
          var that=this;
          var reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/; //验证规则
          if((!reg.test(str))&&(!type)){
            this.$message.warning('手机格式输入错误')
          }
          return reg.test(str);
        },
        reg_password(str){// 正则判断 密码
          var that=this;
          var reg = /^.{6,}$/; //验证规则
          return reg.test(str.replace(/\s/g, ''));
        },
        reg_idCard(str,type){// 正则判断 身份证号
          if(!str) return
          var that=this;
          let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
          let _IDre15 =  /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/
          if((!(_IDRe18.test(str) || _IDre15.test(str)))&&(!type)){
            this.$message.warning('身份证格式输入错误')
          }
          return _IDRe18.test(str) || _IDre15.test(str);
        },
        changeTime(str){// 时间转换
          if(!str){
            return
          }
          if(str.indexOf('T')!=-1){
            return str.replace(/T/, "  ")
          }else{
            return str
          }
        }


    }
}


// WEBPACK FOOTER //
// ./src/assets/js/index.js